import { useSnackbar } from "notistack";
import React from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import Input from "../../components/Input";
import AlertModal from "../../components/Modal";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import StatusAlert from "../../components/StatusAlert";
import Functions from "../../helpers/Functions";
import { Reducers } from "../../Interfaces/Interfaces";
import {
  declineRequest,
  getAggregatorRequests,
  recommendRequest,
} from "../../redux/actions/POSAction";
import { getPOSDashboard } from "../../redux/actions/userActions";
import PrimaryTheme from "../../Themes/Primary";
import "./pos.scss";
export default function RecommendPos() {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state: Reducers) => state.user);
  const { enqueueSnackbar } = useSnackbar();
  const alert = useSelector((state: Reducers) => state.alert);
  const dashboard = useSelector((state: Reducers) => state.dashboard);
  const requests = useSelector((state: Reducers) => state.requests);

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [agent, setAgent]: any = React.useState({});
  const [noOfRequests, setRequests] = React.useState(
    agent.numberOfTerminalRequested
  );
  const [reason, setReason] = React.useState("");
  const [logistics] = React.useState("");
  // const [activationFee] = React.useState('');
  const [pin, setPin] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [type, setType] = React.useState(0);
  const [title, setTitle] = React.useState("");
  const [subtitle, setSubtitle] = React.useState("");
  const [status, setStatus]: any = React.useState(undefined);
  const [recommended, setRecommended]: any = React.useState(undefined);

  let list = requests && requests.items;

  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const handleAction = (item: any, index: number) => {
    setAgent(item);
    setType(index);

    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };

  const handleBackAction = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    history.push("/dashboard");
  };

  const handleReload = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });

    window.location.reload();
  };

  React.useEffect(() => {
    if (status !== undefined) {
      filter.status = status;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch(getAggregatorRequests(paginationConfig));
    }

    if (recommended !== undefined) {
      // eslint-disable-next-line eqeqeq
      filter.hasRecommendation = recommended == 1 ? true : false;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch(getAggregatorRequests(paginationConfig));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, recommended, dispatch]);

  React.useEffect(() => {
    if (Object.entries(agent).length !== 0) {
      setRequests(agent.numberOfTerminalRequested);
    }
  }, [agent]);

  const closeModal = (e: any) => {
    e.preventDefault();

    dispatch({ type: "ALERT_MODAL", payload: false });
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    dispatch(getAggregatorRequests(paginationConfig));
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    setLoading(true);
    // dispatch({
    //   type: 'ALERT_MODAL',
    //   payload: false
    // });

    const data = {
      requestId: agent.id,
      comment: "comment",
      transactionPin: pin,
      terminalAcquisitionFee: logistics,
    };

    dispatch(recommendRequest(data));
  };

  const DeclineRequest = (e: any) => {
    e.preventDefault();

    setLoading(true);

    // dispatch({
    //   type: 'ALERT_MODAL',
    //   payload: false
    // });

    const data = {
      requestId: agent.id,
      comment: reason,
      transactionPin: pin,
    };

    dispatch(declineRequest(data));
  };

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    // dispatch(getPOSDashboard(user.id));

    return () => {
      // dispatch({
      //   type: 'DASHBOARD',
      //   payload: {}
      // })
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch(getAggregatorRequests(paginationConfig));

    return () => {
      dispatch({
        type: "REQUESTS",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "ALERT",
          payload: {},
        });

        setLoading(false);

        dispatch(getAggregatorRequests(paginationConfig));
      } else {
        handleReload();

        if (type === 1) {
          setSubtitle(
            `The POS Request by your agent ${agent.agentName} ${agent.agentPhoneNumber} for ${noOfRequests} Terminals has been sent for processing. Your agent should maintain a healthy wallet balance to enable the activation fee be charge for final approval.`
          );
          setTitle("POS Request Recommended Successfully");
        } else {
          setSubtitle(`Your Agent’s POS Request has been declined`);
          setTitle("POS Request Declined Successfully");
        }

        dispatch({
          type: "STATUS_ALERT",
          payload: true,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });

        setLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert]);

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar canGoBack onClick={() => history.goBack()} />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          backgroundColor: PrimaryTheme.white,
        }}
      >
        <div
          className="col-md-11 col  ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",
          }}
        >
          <h1
            className="mb-5 rec-pos-title"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle,
            }}
          >
            Recommend POS
          </h1>

          {/* cards  */}
          <div className="row mb-5" style={{ paddingLeft: "20px" }}>
            <div
              className="col-md col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Total Requests
              </h5>
              <h2
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard.terminalRequests ? dashboard.terminalRequests : 0}
              </h2>
            </div>

            <div
              className="col-md col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Total Approved
              </h5>
              <h2
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard.approvedRequests ? dashboard.approvedRequests : 0}
              </h2>
            </div>

            <div
              className="col-md col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Total Declined
              </h5>
              <h2
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                N/A
              </h2>
            </div>

            <div
              className="col"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Total Rejected
              </h5>
              <h2
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                N/A
              </h2>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              <Filters
                name="POS Requests"
                isRequest
                status={status}
                statusChange={(e: any) => setStatus(e.target.value)}
                recommended={recommended}
                onRecommend={(e: any) => setRecommended(e.target.value)}
              />
            </div>
          </div>

          <div className="row " style={{ paddingBottom: "100px" }}>
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <th scope="col">S/N</th>
                          <th scope="col">Agent ID</th>
                          <th scope="col">Agent Name</th>
                          <th scope="col">POS Request</th>
                          <th scope="col">Activation Fee</th>
                          <th scope="col">Action</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr
                              key={index}
                              style={{
                                textAlign: "center",
                              }}
                            >
                              <th scope="row">{getIndexSeed(index)}</th>
                              <td>{item.agentPhoneNumber}</td>
                              <td>{item.agentName}</td>
                              <td>
                                {item.numberOfTerminalRequested.toLocaleString()}
                              </td>
                              <td>
                                {item.terminalActivationFee
                                  ? Functions.getCurrency(
                                      item.terminalActivationFee
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {item.status === 1 ? (
                                  <div
                                    className="btn-group"
                                    role="group"
                                    aria-label="Basic example"
                                  >
                                    <span
                                      onClick={() => handleAction(item, 1)}
                                      className="btn btn-success badge-pill small pl-3 pr-3"
                                      style={{
                                        fontSize: PrimaryTheme.fontSizes?.small,
                                      }}
                                    >
                                      Recommend
                                    </span>
                                    <span
                                      onClick={() => handleAction(item, 2)}
                                      className="btn btn-warning badge-pill small pl-3 pr-3"
                                      style={{
                                        fontSize: PrimaryTheme.fontSizes?.small,
                                      }}
                                    >
                                      Decline
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className="btn-group"
                                    role="group"
                                    aria-label="Basic example"
                                  >
                                    <button
                                      disabled
                                      className="btn btn-success badge-pill small pl-3 pr-3"
                                      style={{
                                        fontSize: PrimaryTheme.fontSizes?.small,
                                      }}
                                    >
                                      {item.hasRecommendation
                                        ? "Recommended"
                                        : "Recommend"}
                                    </button>
                                    <button
                                      disabled
                                      className={
                                        item.declined
                                          ? "btn-danger btn badge-pill small pl-3 pr-3"
                                          : "btn-warning btn badge-pill small pl-3 pr-3"
                                      }
                                      style={{
                                        fontSize: PrimaryTheme.fontSizes?.small,
                                      }}
                                    >
                                      {item.declined ? "Declined" : "Decline"}
                                    </button>
                                  </div>
                                )}
                              </td>

                              <td>
                                {item.status === 1 && (
                                  <span className="badge badge-pill badge-warning p-2 pl-3 pr-3">
                                    {item.requestStatusName}
                                  </span>
                                )}

                                {item.status === 2 && (
                                  <span className="badge badge-pill badge-danger p-2 pl-3 pr-3">
                                    {item.requestStatusName}
                                  </span>
                                )}

                                {item.status === 5 && (
                                  <span className="badge badge-pill badge-danger p-2 pl-3 pr-3">
                                    {item.requestStatusName}
                                  </span>
                                )}

                                {item.status === 3 && (
                                  <span className="badge badge-pill badge-success p-2 pl-3 pr-3">
                                    {item.requestStatusName}
                                  </span>
                                )}

                                {item.status === 7 && (
                                  <span className="badge badge-pill badge-success p-2 pl-3 pr-3">
                                    {item.requestStatusName}
                                  </span>
                                )}

                                {item.status === 9 && (
                                  <span className="badge badge-pill badge-info p-2 pl-3 pr-3">
                                    {item.requestStatusName}
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    {requests.total > pageSize && (
                      <PaginationControlled
                        onPageSizeChange={handlePageSizeChange}
                        onChange={handleChange}
                        page={page}
                        total={requests.total && requests.total}
                        pageSize={pageSize}
                      />
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>

        {type === 1 && (
          <AlertModal showClose>
            <div className="col-md-12 pl-5 pr-5 pb-5 text-center">
              <div className="col-md-12">
                <span
                  className="badge-pill p-3 d-block col-8 ml-auto mr-auto"
                  style={{
                    background: PrimaryTheme.warn,
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                  }}
                >
                  Recommend Request
                </span>
              </div>

              <div className="col-md-12 ml-auto mr-auto mt-3 mb-3">
                <div className="row m-0 ">
                  <div className="col-6">
                    <p
                      className="mb-0 text-right"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RegularFont,
                        fontSize: PrimaryTheme.fontSizes?.anchor,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {" "}
                      <b>Agent Name: </b>
                    </p>
                  </div>
                  <div className="col-6 text-left">{agent.agentName}</div>

                  <div className="col-6">
                    <p
                      className="mb-0 text-right"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RegularFont,
                        fontSize: PrimaryTheme.fontSizes?.anchor,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {" "}
                      <b>Agent Phone: </b>
                    </p>
                  </div>
                  <div className="col-6 text-left">
                    {agent.agentPhoneNumber}
                  </div>

                  <div className="col-6">
                    <p
                      className="mb-0 text-right"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RegularFont,
                        fontSize: PrimaryTheme.fontSizes?.anchor,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {" "}
                      <b>Nos of Requests: </b>
                    </p>
                  </div>
                  <div className="col-6 text-left">
                    {agent.numberOfTerminalRequested}
                  </div>

                  <div className="col-6">
                    <p
                      className="mb-0 text-right"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RegularFont,
                        fontSize: PrimaryTheme.fontSizes?.anchor,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {" "}
                      <b>EOD: </b>
                    </p>
                  </div>
                  <div className="col-6 text-left p-0">
                    {" "}
                    <button className="btn btn-link">View</button>
                  </div>

                  <div className="col-6">
                    <p
                      className="mb-0 text-right"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RegularFont,
                        fontSize: PrimaryTheme.fontSizes?.anchor,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {" "}
                      <b>Agent Profile: </b>
                    </p>
                  </div>
                  <div className="col-6 text-left p-0">
                    {" "}
                    <button className="btn btn-link">View</button>
                  </div>
                </div>
              </div>

              <form noValidate className="col-md-9 ml-auto mr-auto">
                <div className="form-group mb-0 text-left">
                  <label htmlFor="">Nos of Requests</label>
                  <Input
                    type="number"
                    placeholder="Requests"
                    autoComplete="text"
                    showIcon
                    // valid={emailValid}
                    value={noOfRequests}
                    disabled
                    inputMode="tel"
                    onChange={(e) => setRequests(e.target.value)}
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>

                <div className="form-group mb-0 text-left">
                  <label htmlFor="">Logistics</label>
                  <Input
                    type="text"
                    placeholder="Logistics"
                    autoComplete="text"
                    showIcon
                    // valid={emailValid}
                    value={Functions.getCurrency(logistics)}
                    // onChange={e => setLogistics(e.target.value)}
                    disabled
                    inputMode="tel"
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>

                <div className="form-group mb-0 text-left">
                  <label htmlFor="">Logistics</label>
                  <Input
                    type="text"
                    placeholder="Logistics"
                    autoComplete="text"
                    showIcon
                    // valid={emailValid}
                    value={Functions.getCurrency(logistics)}
                    // onChange={e => setLogistics(e.target.value)}
                    disabled
                    inputMode="tel"
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>

                <div className="row m-0 justify-content-center align-items-center">
                  <div className="col-md-12">
                    <label htmlFor="" className="text-bold">
                      Enter PIN
                    </label>
                  </div>
                  <OtpInput
                    value={pin}
                    onChange={(e: any) => setPin(e)}
                    numInputs={4}
                    isInputNum
                    shouldAutoFocus
                    inputStyle={{
                      width: "45px",
                      height: "45px",
                      fontSize: "24px",
                      padding: 0,
                      textAlign: "center",
                      borderRadius: 10,
                      border: "1px solid",
                      borderColor: PrimaryTheme.primary,
                    }}
                    isInputSecure
                    separator={<span className="mr-3"> </span>}
                  />
                </div>

                <div className="form-group mt-5 mb-0">
                  <Input
                    onClick={handleSubmit}
                    type="button"
                    isInput
                    value={loading ? "Processing..." : "Confirm"}
                    disabled={pin.length === 0}
                    style={{
                      background: PrimaryTheme.primary,
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.white,
                    }}
                    className="text-bold border-0 col-md-6"
                  />
                  <button className="btn btn-light" onClick={closeModal}>
                    Back
                  </button>
                </div>
              </form>
            </div>
          </AlertModal>
        )}

        {type === 2 && (
          <AlertModal showClose>
            <div className="col-md-12 pl-5 pr-5 pb-5 text-center">
              <div className="col-md-12">
                <span
                  className="badge-pill p-3 d-block col-8 ml-auto mr-auto"
                  style={{
                    background: PrimaryTheme.warn,
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                  }}
                >
                  Decline Request
                </span>
              </div>

              <div className="col-md-12 ml-auto mr-auto mt-3 mb-3">
                <div className="row m-0 ">
                  <div className="col-6">
                    <p
                      className="mb-0 text-right"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RegularFont,
                        fontSize: PrimaryTheme.fontSizes?.anchor,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {" "}
                      <b>Agent Name: </b>
                    </p>
                  </div>
                  <div className="col-6 text-left">{agent.agentName}</div>

                  <div className="col-6">
                    <p
                      className="mb-0 text-right"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RegularFont,
                        fontSize: PrimaryTheme.fontSizes?.anchor,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {" "}
                      <b>Agent Phone: </b>
                    </p>
                  </div>
                  <div className="col-6 text-left">
                    {agent.agentPhoneNumber}
                  </div>

                  <div className="col-6">
                    <p
                      className="mb-0 text-right"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RegularFont,
                        fontSize: PrimaryTheme.fontSizes?.anchor,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {" "}
                      <b>Nos of Requests: </b>
                    </p>
                  </div>
                  <div className="col-6 text-left">
                    {agent.numberOfTerminalRequested}
                  </div>

                  <div className="col-6">
                    <p
                      className="mb-0 text-right"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RegularFont,
                        fontSize: PrimaryTheme.fontSizes?.anchor,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {" "}
                      <b>EOD: </b>
                    </p>
                  </div>
                  <div className="col-6 text-left p-0">
                    {" "}
                    <button className="btn btn-link">View</button>
                  </div>

                  <div className="col-6">
                    <p
                      className="mb-0 text-right"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RegularFont,
                        fontSize: PrimaryTheme.fontSizes?.anchor,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {" "}
                      <b>Agent Profile: </b>
                    </p>
                  </div>
                  <div className="col-6 text-left p-0">
                    {" "}
                    <button className="btn btn-link">View</button>
                  </div>
                </div>
              </div>

              <form noValidate className="col-md-9 ml-auto mr-auto">
                <div className="form-group mb-0 text-left">
                  <label htmlFor="">Reason</label>
                  <Input
                    type="text"
                    placeholder="Reason"
                    autoComplete="text"
                    showIcon
                    // valid={emailValid}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    // disabled={submitted}
                    autoFocus
                    inputMode="tel"
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>

                <div className="row m-0 justify-content-center align-items-center">
                  <div className="col-md-12">
                    <label htmlFor="" className="text-bold">
                      Enter PIN
                    </label>
                  </div>
                  <OtpInput
                    value={pin}
                    onChange={(e: any) => setPin(e)}
                    numInputs={4}
                    isInputNum
                    shouldAutoFocus
                    inputStyle={{
                      width: "45px",
                      height: "45px",
                      fontSize: "24px",
                      padding: 0,
                      textAlign: "center",
                      borderRadius: 10,
                      border: "1px solid",
                      borderColor: PrimaryTheme.primary,
                    }}
                    isInputSecure
                    separator={<span className="mr-3"> </span>}
                  />
                </div>

                <div className="form-group mt-5 mb-0">
                  <Input
                    onClick={DeclineRequest}
                    type="button"
                    isInput
                    value={loading ? "Processing..." : "Confirm"}
                    disabled={pin.length === 0}
                    style={{
                      background: PrimaryTheme.primary,
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.white,
                    }}
                    className="text-bold border-0 col-md-6"
                  />
                  <button className="btn btn-light" onClick={closeModal}>
                    Back
                  </button>
                </div>
              </form>
            </div>
          </AlertModal>
        )}

        <StatusAlert
          title={title}
          subtitle={subtitle}
          buttonTitle="View POS Requests"
          backTitle="Back to Main Dashboard"
          goBack={handleBackAction}
          onClick={handleReload}
        />
      </div>
    </React.Fragment>
  );
}
